import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getMoneyReceiptComplimentaryItems,
  getMoneyReceiptComplimentaryItem,
  createMoneyReceiptComplimentaryItem,
  updateMoneyReceiptComplimentaryItem,
  deleteMoneyReceiptComplimentaryItem,
  getAllMoneyReceiptComplimentaryItems,
} from "api/complimentaryItemApi"

export const COMPLIMENTARY_ITEM_QUERY_KEY = "service-lists"

export const useMoneyReceiptComplimentaryItems = (params = {}, enabled = true) => {
  return usePaginatedResource(
    COMPLIMENTARY_ITEM_QUERY_KEY,
    getMoneyReceiptComplimentaryItems,
    params,
    enabled
  )
}

export const useMoneyReceiptComplimentaryItem = (id, enabled = true) => {
  return useResourceItem(
    COMPLIMENTARY_ITEM_QUERY_KEY,
    getMoneyReceiptComplimentaryItem,
    id,
    enabled
  )
}

export const useCreateMoneyReceiptComplimentaryItem = () => {
  return useCreateResource(
    createMoneyReceiptComplimentaryItem,
    COMPLIMENTARY_ITEM_QUERY_KEY
  )
}

export const useEditMoneyReceiptComplimentaryItem = () => {
  return useEditResource(
    updateMoneyReceiptComplimentaryItem,
    COMPLIMENTARY_ITEM_QUERY_KEY
  )
}

export const useDeleteMoneyReceiptComplimentaryItem = () => {
  return useDeleteResource(
    deleteMoneyReceiptComplimentaryItem,
    COMPLIMENTARY_ITEM_QUERY_KEY
  )
}

export const useAllMoneyReceiptComplimentaryItems = (params = {}, enabled = true) => {
  return usePaginatedResource(
    [COMPLIMENTARY_ITEM_QUERY_KEY, "all"],
    queryParams => getAllMoneyReceiptComplimentaryItems(queryParams),
    params,
    enabled
  )
}
